import { toast } from "@/hooks/use-toast"

interface ToastOptions {
  title?: string
  description?: string
  duration?: number
}

export const toastSuccess = ({ title = "Sucesso!", description, duration = 5000 }: ToastOptions = {}) => {
  return toast({
    variant: "success",
    title,
    description,
    duration,
  })
}

export const toastError = ({ title = "Erro!", description, duration = 5000 }: ToastOptions = {}) => {
  return toast({
    variant: "error",
    title,
    description,
    duration,
  })
}

export const toastWarning = ({ title = "Atenção!", description, duration = 5000 }: ToastOptions = {}) => {
  return toast({
    variant: "warning",
    title,
    description,
    duration,
  })
}

export const toastInfo = ({ title = "Informação", description, duration = 5000 }: ToastOptions = {}) => {
  return toast({
    variant: "info",
    title,
    description,
    duration,
  })
}

export const toastDefault = ({ title, description, duration = 5000 }: ToastOptions = {}) => {
  return toast({
    variant: "default",
    title,
    description,
    duration,
  })
}

// Funções de conveniência para casos comuns
export const showSuccessMessage = (message: string) => {
  return toastSuccess({ description: message })
}

export const showErrorMessage = (message: string) => {
  return toastError({ description: message })
}

export const showWarningMessage = (message: string) => {
  return toastWarning({ description: message })
}

export const showInfoMessage = (message: string) => {
  return toastInfo({ description: message })
}

// Função para operações de carrinho
export const showCartSuccess = (action: string, itemName?: string) => {
  const messages = {
    add: `${itemName ? itemName + ' foi' : 'Item'} adicionado ao carrinho`,
    remove: `${itemName ? itemName + ' foi' : 'Item'} removido do carrinho`,
    update: `Quantidade ${itemName ? 'de ' + itemName : ''} atualizada`,
    clear: 'Carrinho limpo com sucesso'
  }
  
  return toastSuccess({ 
    title: "Carrinho atualizado!",
    description: messages[action as keyof typeof messages] || 'Operação realizada com sucesso'
  })
}

// Função para operações de autenticação
export const showAuthSuccess = (action: string) => {
  const messages = {
    login: 'Login realizado com sucesso!',
    logout: 'Logout realizado com sucesso!',
    register: 'Conta criada com sucesso!',
    update: 'Perfil atualizado com sucesso!'
  }
  
  return toastSuccess({ 
    description: messages[action as keyof typeof messages] || 'Operação realizada com sucesso'
  })
}

// Função para sucesso de API
export const showApiSuccess = (message: string) => {
  return toastSuccess({ 
    title: "Operação realizada!",
    description: message 
  })
}

// Função para erros de API
export const showApiError = (error: any) => {
  const message = error?.response?.data?.message || error?.message || 'Ocorreu um erro inesperado'
  return toastError({ 
    title: "Erro na operação",
    description: message 
  })
}